import { Component, Input, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

export interface AccordionItem {
  title: string;
  content: string;
}

@Component({
  selector: 'app-accordion-default',
  imports: [MatExpansionModule],
  templateUrl: './accordion-default.html',
  styleUrl: './accordion-default.scss',
})
export class AccordionDefault {
  @Input() lista: AccordionItem[] = [];
  @Input() titulo: string = '';
  @Input() isOpen = signal(false);
}
